import { PendingPayableRow } from 'services/reportsApi';

export interface PendingPayablesSummary {
  count: number;
  total_amount: number;
}

export const summarizePendingPayables = (rows: PendingPayableRow[]): PendingPayablesSummary => {
  const summary: PendingPayablesSummary = {
    count: 0,
    total_amount: 0,
  };
  for (const row of rows) {
    summary.count += 1;
    summary.total_amount += Number.isFinite(row.amount) ? row.amount : 0;
  }
  return summary;
};

export const uniqueProperties = (
  rows: PendingPayableRow[]
): Array<{ id: string; name: string }> => {
  const seen = new Map<string, string>();
  for (const row of rows) {
    if (!seen.has(row.propertyId)) {
      seen.set(row.propertyId, row.propertyName || 'Unknown property');
    }
  }
  return Array.from(seen.entries())
    .map(([id, name]) => ({ id, name }))
    .sort((a, b) => a.name.localeCompare(b.name));
};
